import React from 'react'
import { Result } from 'antd'
import Video from 'twilio-video'

function UnsupportedBrowserWarning({ children }: { children: React.ReactElement }) {
	if (!Video.isSupported) {
		return (
			<Result
				title="Browser or context not supported!"
				subTitle="Please open this application in one of the supported browsers!"
			/>
		)
	}

	return children
}

export default UnsupportedBrowserWarning
